var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"avatar",style:(("width: " + _vm.size + "px; height: " + _vm.size + "px; background-image: url(" + (_vm.image || _vm.identicon) + ")")),on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }